import React from 'react'
import { readStored, writeStored } from './safeStorage'

// Tema tampilan: 'system' (ikuti OS), 'light', atau 'dark'.
//
// Pilihan pengguna disimpan per peramban. Yang ditulis ke <html data-theme> selalu
// hasil AKHIR ('light' atau 'dark'), jadi stylesheet cukup satu blok gelap —
// `:root[data-theme="dark"]` — tanpa menduplikasi token ke dalam media query.
//
// index.html menjalankan skrip kecil dengan logika yang sama SEBELUM halaman
// digambar, supaya pengguna tema gelap tidak melihat kilat putih saat memuat.
// Kunci penyimpanan dan aturan resolusinya harus tetap sama di kedua tempat.
export const THEME_KEY = 'gladhy_theme'
export const THEME_PREFS = ['system', 'light', 'dark']

const darkQuery = () =>
  typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia('(prefers-color-scheme: dark)')
    : null

let pref = (() => {
  const saved = readStored(THEME_KEY)
  return THEME_PREFS.includes(saved) ? saved : 'system'
})()

const listeners = new Set()
const notify = () => listeners.forEach((fn) => fn())

const resolved = () => (pref === 'system' ? (darkQuery()?.matches ? 'dark' : 'light') : pref)

function apply() {
  const root = document.documentElement
  const mode = resolved()
  root.dataset.theme = mode
  // Mengatur warna kontrol bawaan peramban: scrollbar, input tanggal, dropdown.
  root.style.colorScheme = mode
}

export function setThemePref(next) {
  if (!THEME_PREFS.includes(next)) return
  pref = next
  writeStored(THEME_KEY, next)
  apply()
  notify()
}

// Dipanggil sekali saat aplikasi mulai. Pada 'system', mengikuti perubahan OS
// secara langsung (mis. jadwal otomatis siang/malam).
export function initTheme() {
  apply()
  darkQuery()?.addEventListener?.('change', () => {
    if (pref === 'system') { apply(); notify() }
  })
}

const subscribe = (fn) => {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
// Snapshot berupa string supaya perbandingan referensinya stabil.
const snapshot = () => `${pref}|${resolved()}`

export function useTheme() {
  const snap = React.useSyncExternalStore(subscribe, snapshot)
  const [current, mode] = snap.split('|')
  return { pref: current, resolved: mode, setPref: setThemePref }
}
